const slugify = require('slugify');

const ourSlugify = (val) => {
  const result = slugify(val, {
    lower: true,
    remove: /[^\w\s_+()-]/g,
  });
  return result;
};

export { ourSlugify as slugify };
